import { get, post } from "./request";
import { buildApiUrl, API_CONFIG } from "./config";
import type { ApiResponse, FavoriteItem } from "./types";

// 收藏相关API
export const likeApi = {
  /**
   * 点赞帖子
   * @param tid - 帖子ID
   * @param target_type - 目标类型
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  add: (
    target_id: number,
    target_type: string,
    game_id: number
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.LIKE,
      API_CONFIG.ACTIONS.ADD,
      {
        target_id,
        target_type,
        game_id,
      }
    );
    return get<ApiResponse>(url);
  },

  /**
   * 取消点赞帖子
   * @param tid - 帖子ID
   * @param target_type - 目标类型
   * @param game_id - 游戏ID
   * @returns Promise<ApiResponse>
   */
  remove: (
    target_id: number,
    target_type: string,
    game_id: number
  ): Promise<ApiResponse> => {
    const url = buildApiUrl(
      API_CONFIG.CONTROLLERS.LIKE,
      API_CONFIG.ACTIONS.REMOVE,
      {
        target_id,
        target_type,
        game_id,
      }
    );
    return get<ApiResponse>(url);
  },
};
